import { Button, Container, Grid, IconButton } from '@material-ui/core'
import { ImportExport, Search } from '@material-ui/icons'
import { useEffect, useState } from 'react'
import { CSVLink } from 'react-csv'
import { useDispatch, useSelector } from 'react-redux'
import { sendAdminInviteEmail } from '../../../actions/emailActions'
import {
  activateUser,
  deactivateUser,
  deleteUser,
  listUsers,
} from '../../../actions/userActions'
import filterIcon from '../../../assets/img/icons/filter.svg'
import { EMAIL_INVITE_RESET } from '../../../constants/emailConstants'
import {
  USER_ACTIVATE_RESET,
  USER_ADMIN_UPDATE_INFO_RESET,
  USER_DEACTIVATE_RESET,
  USER_DELETE_RESET,
  USER_INVITE_RESET,
  USER_UPDATE_INFO_RESET,
} from '../../../constants/userConstants'
import locationsList from '../../../data/locations'
import { useDateFormatter } from '../../../hooks/useDateFormatter'
import { useInput } from '../../../hooks/useInput'
import ActionsMenu from '../../ActionsMenu/ActionsMenu'
import AutoCompleteSelect from '../../Form/AutoCompleteSelect'
import SearchInput from '../../Form/SearchInput'
import SelectInput from '../../Form/SelectInput'
import Loader from '../../Loader/Loader'
import Message from '../../Message/Message'
import ModalPopUp from '../../ModalPopUp/ModalPopUp'
import ToastMessage from '../../ToastMessage/ToastMessage'
import AddAdminUser from './AddAdminUser'
import EditAdminUser from './EditAdminUser'
import UserTable from './UserTable'

const UserLibrary = () => {
  const dispatch = useDispatch()

  const { bind: bindSearch, value: searchValue } = useInput('')
  const { value: location, setValue: setLocation } = useInput('')
  const { bind: bindRole, value: role, setValue: setRole } = useInput('')
  const { bind: bindStatus, value: status, setValue: setStatus } = useInput('')
  const [usersSet, setUsersSet] = useState(false)
  const [showSearch, setShowSearch] = useState(false)
  const [userToEdit, setUserToEdit] = useState(false)
  const [showEditUser, setShowEditUser] = useState(false)
  const [showAddUser, setShowAddUser] = useState(false)
  const [showDeactivateModal, setShowDeactivateModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [showActivateModal, setShowActivateModal] = useState(false)
  const [updateUserToast, setUpdateUserToast] = useState(false)
  const [emailSentToast, setEmailSentToast] = useState(false)
  const [deactivateUserToast, setDeactivateUserToast] = useState(false)
  const [activateUserToast, setActivateUserToast] = useState(false)
  const [deleteUserToast, setDeleteUserToast] = useState(false)
  const [filteredUsers, setFilteredUsers] = useState([])
  const [sortValue, setSortValue] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [sorting, setSorting] = useState(false)
  const [showFilters, setShowFilters] = useState(false)
  const [formattedUsers, setFormattedUsers] = useState([])

  const { userInfo } = useSelector((state) => state.userLogin)
  const { loading, error, users } = useSelector((state) => state.userList)
  const { invitedUser, success: inviteUserSuccess } = useSelector(
    (state) => state.userInvite
  )
  const { success: emailInviteSuccess } = useSelector(
    (state) => state.emailInvite
  )
  const { success: userUpdateSuccess, user: updatedUser } = useSelector(
    (state) => state.userUpdateInfo
  )
  const { success: userDeleteSuccess } = useSelector(
    (state) => state.userDelete
  )
  const { success: successDeactivate } = useSelector(
    (state) => state.userDeactivate
  )
  const { success: successActivate } = useSelector(
    (state) => state.userActivate
  )
  const { success: updateAdminUserSuccess } = useSelector(
    (state) => state.userUpdateAdminInfo
  )

  const headers = [
    { label: 'Email', key: 'email' },
    { label: 'First Name', key: 'firstName' },
    { label: 'Last Name', key: 'lastName' },
    { label: 'Role', key: 'role' },
    { label: 'Company', key: 'company.companyName' },
    { label: 'Status', key: 'status' },
    { label: 'Marketing Consent', key: 'marketingConsent' },
    { label: 'Phone', key: 'phone' },
    { label: 'Created At', key: 'createdAt' },
    { label: 'Last active', key: 'lastActive' },
  ]

  const readableDate = useDateFormatter(new Date(), 'MM-DD-YYYY').replace(
    /[/]/g,
    '-'
  )

  useEffect(() => {
    if (!usersSet) {
      dispatch(listUsers(userInfo._id))
    }

    if (users) {
      setFilteredUsers(users)
      setFormattedUsers(
        users.map((user) => ({
          ...user,
          createdAt: user.createdAt ? user.createdAt.substring(0, 10) : '',
          lastActive: user.lastActive ? user.lastActive.substring(0, 10) : '',
        }))
      )

      setUsersSet(true)
    }
  }, [dispatch, users, usersSet, userInfo])

  useEffect(() => {
    if (searchValue) {
      const filteredUserClone = filteredUsers.filter((x) => {
        let name = x.firstName + ' ' + x.lastName
        return name.toLowerCase().includes(searchValue.toLowerCase())
          ? x
          : false
      })
      setFilteredUsers(filteredUserClone)
    } else {
      setFilteredUsers(users)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue, setFilteredUsers])

  useEffect(() => {
    setSorting(true)

    if (sortValue === 'az') {
      setFilteredUsers(
        filteredUsers.sort((a, b) => a.lastName.localeCompare(b.lastName))
      )
    }

    if (sortValue === 'za') {
      setFilteredUsers(
        filteredUsers.sort((a, b) => b.lastName.localeCompare(a.lastName))
      )
    }

    if (sortValue === 'lastUpdated') {
      setFilteredUsers(
        filteredUsers.sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))
      )
    }

    if (sortValue === 'newest') {
      setFilteredUsers(
        filteredUsers.sort((a, b) => b.createdAt.localeCompare(a.createdAt))
      )
    }

    setTimeout(() => setSorting(false), 200)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setFilteredUsers, sortValue, setSorting])

  useEffect(() => {
    if (inviteUserSuccess) {
      window.scrollTo(0, 0)
      setShowAddUser(false)
      dispatch(sendAdminInviteEmail(invitedUser))
      dispatch({ type: USER_INVITE_RESET })
      dispatch(listUsers(userInfo._id))
    }

    if (emailInviteSuccess) {
      window.scrollTo(0, 0)
      setEmailSentToast(true)
      dispatch({ type: EMAIL_INVITE_RESET })
      dispatch(listUsers(userInfo._id))
    }

    if (userUpdateSuccess) {
      window.scrollTo(0, 0)
      setUpdateUserToast(true)
      setUserToEdit('')
      dispatch({ type: USER_UPDATE_INFO_RESET })
      dispatch(listUsers(userInfo._id))
    }

    if (successDeactivate) {
      window.scrollTo(0, 0)
      setDeactivateUserToast(true)
      setShowDeactivateModal(false)
      dispatch({ type: USER_DEACTIVATE_RESET })
      dispatch(listUsers(userInfo._id))
    }

    if (successActivate) {
      window.scrollTo(0, 0)
      setActivateUserToast(true)
      setShowActivateModal(false)
      dispatch({ type: USER_ACTIVATE_RESET })
      dispatch(listUsers(userInfo._id))
    }

    if (updateAdminUserSuccess) {
      window.scrollTo(0, 0)
      setShowEditUser(false)
      setUpdateUserToast(true)
      dispatch({ type: USER_ADMIN_UPDATE_INFO_RESET })
      dispatch(listUsers(userInfo._id))
    }

    if (userDeleteSuccess) {
      window.scrollTo(0, 0)
      setShowEditUser(false)
      setShowDeleteModal(false)
      setDeleteUserToast(true)
      dispatch({ type: USER_DELETE_RESET })
      dispatch(listUsers(userInfo._id))
    }
  }, [
    updatedUser,
    invitedUser,
    inviteUserSuccess,
    dispatch,
    userUpdateSuccess,
    successDeactivate,
    userInfo,
    successActivate,
    updateAdminUserSuccess,
    userDeleteSuccess,
    emailInviteSuccess,
  ])

  useEffect(() => {
    if (users) {
      let userClone = [...users]

      if (location !== '') {
        userClone = userClone.filter(
          (x) =>
            x.location &&
            x.location.toLowerCase().includes(location.toLowerCase())
        )
      }

      if (role !== '') {
        userClone = userClone.filter(
          (x) => x.role && x.role.toLowerCase().includes(role.toLowerCase())
        )
      }

      if (status !== '') {
        userClone = userClone.filter(
          (x) =>
            x.status && x.status.toLowerCase().includes(status.toLowerCase())
        )
      }

      setFilteredUsers(userClone)
    }
  }, [location, setFilteredUsers, users, role, status])

  const confirmDeactivateUser = () => {
    dispatch(deactivateUser(userToEdit))
  }

  const confirmActivateUser = () => {
    dispatch(activateUser(userToEdit))
  }

  const confirmDeleteUser = () => {
    dispatch(deleteUser(userToEdit._id))
  }

  const handleClear = () => {
    setLocation('')
    setRole('')
    setStatus('')
  }

  return (
    <div className="library gray-bg">
      <Container className="p-b-100">
        <h3 className="page-title accent-left">User library</h3>

        <div className="flex flex-end m-b-16" style={{ height: 33 }}>
          {showSearch ? (
            <SearchInput bindValue={bindSearch} setShowSearch={setShowSearch} />
          ) : (
            <IconButton onClick={() => setShowSearch(true)}>
              <Search />
            </IconButton>
          )}
          <ActionsMenu
            icon={<ImportExport />}
            options={[
              { onClick: () => setSortValue('az'), label: 'A - Z' },
              { onClick: () => setSortValue('za'), label: 'Z - A' },
              { onClick: () => setSortValue('newest'), label: 'Newest' },
              {
                onClick: () => setSortValue('lastUpdated'),
                label: 'Last updated',
              },
            ]}
          />
          <IconButton
            className="m-l-5"
            style={{ width: 32, height: 33 }}
            onClick={() => setShowFilters(!showFilters)}
          >
            <img style={{ width: 20 }} src={filterIcon} alt="Filter" />
          </IconButton>
          {(userInfo.role === 'Manager' || userInfo.role === 'Support') && (
            <>
              <Button
                className="m-l-24"
                variant="outlined"
                color="primary"
                onClick={() => setShowAddUser(true)}
              >
                Add member
              </Button>
              {users && users.length > 0 && (
                <CSVLink
                  data={formattedUsers}
                  headers={headers}
                  filename={`MyQuality Users - ${readableDate}.csv`}
                >
                  <Button
                    className="m-l-24"
                    variant="contained"
                    color="primary"
                  >
                    Export users
                  </Button>
                </CSVLink>
              )}
            </>
          )}
        </div>

        {showFilters && (
          <div className="filter-bar">
            <div className="flex space-between">
              <label className="fs14 strong">Filters</label>
              <span
                className="link fs12"
                rel="noopener noreferrer"
                target="_blank"
                onClick={handleClear}
              >
                Clear
              </span>
            </div>
            <div className="form-container p-l-0 p-r-0">
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <AutoCompleteSelect
                    name="location"
                    label="Location"
                    options={locationsList}
                    value={location}
                    setValue={setLocation}
                    minWidth={283}
                  />
                </Grid>
                <Grid item xs={3}>
                  <SelectInput
                    name="role"
                    label="Role"
                    options={[
                      { value: 'Manager', label: 'Manager' },
                      { value: 'AE', label: 'AE' },
                      { value: 'User', label: 'User' },
                      { value: 'Support', label: 'Support' },
                    ]}
                    bindValue={bindRole}
                  />
                </Grid>
                <Grid item xs={3}>
                  <SelectInput
                    name="status"
                    label="Status"
                    options={[
                      { value: 'Active', label: 'Active' },
                      { value: 'Deactivated', label: 'Deactivated' },
                      { value: 'Invited', label: 'Invited' },
                      { value: 'Pending', label: 'Pending' },
                    ]}
                    bindValue={bindStatus}
                  />
                </Grid>
              </Grid>
            </div>
          </div>
        )}

        {loading && <Loader />}

        {error && <Message variant="error">{error}</Message>}

        {!loading && !error && filteredUsers && (
          <UserTable
            users={filteredUsers}
            setUserToEdit={setUserToEdit}
            setShowEditUser={setShowEditUser}
            setShowDeactivateModal={setShowDeactivateModal}
            setShowActivateModal={setShowActivateModal}
            setShowDeleteModal={setShowDeleteModal}
          />
        )}
      </Container>

      <ModalPopUp
        title="View member information"
        setShowModal={setShowEditUser}
        showModal={showEditUser}
      >
        <EditAdminUser
          setShowDeactivateModal={setShowDeactivateModal}
          setShowDeleteModal={setShowDeleteModal}
          setShowEditUser={setShowEditUser}
          user={userToEdit}
        />
      </ModalPopUp>

      <ModalPopUp
        title="Add member"
        setShowModal={setShowAddUser}
        showModal={showAddUser}
      >
        <AddAdminUser setShowAddUser={setShowAddUser} />
      </ModalPopUp>

      <ModalPopUp
        title="Deactivate account"
        setShowModal={setShowDeactivateModal}
        showModal={showDeactivateModal}
      >
        <h4 className="m-b-32">
          Are you sure you want to deactivate {userToEdit.firstName}{' '}
          {userToEdit.lastName}'s account?
        </h4>
        <p>
          This member will no longer be to log into the AE Portal when their
          account is deactivated.
        </p>
        <div className="actions m-t-40 flex-end flex">
          <Button
            color="primary"
            variant="outlined"
            className="m-r-24"
            onClick={() => setShowDeactivateModal(false)}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={confirmDeactivateUser}
          >
            Deactivate account
          </Button>
        </div>
      </ModalPopUp>

      <ModalPopUp
        title="Activate user?"
        setShowModal={setShowActivateModal}
        showModal={showActivateModal}
      >
        <h4 className="m-b-32">Activate user?</h4>
        <p>Are you sure you want to activate {userToEdit.email}?</p>
        <div className="actions m-t-40 flex-end flex">
          <Button
            color="primary"
            variant="outlined"
            className="m-r-24"
            onClick={() => setShowActivateModal(false)}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={confirmActivateUser}
          >
            Confirm
          </Button>
        </div>
      </ModalPopUp>

      <ModalPopUp
        title="Delete member"
        setShowModal={setShowDeleteModal}
        showModal={showDeleteModal}
      >
        <h4 className="m-b-32">
          Are you sure you want to delete {userToEdit.firstName}{' '}
          {userToEdit.lastName}'s account?
        </h4>
        <p>
          All records of this member will be deleted. This member will no longer
          have access to the AE Portal and will have to be invited to the AE
          Portal again to have access.{' '}
        </p>
        <div className="actions m-t-40 flex-end flex">
          <Button
            color="primary"
            variant="outlined"
            className="m-r-24"
            onClick={() => setShowDeleteModal(false)}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={confirmDeleteUser}
          >
            Delete member
          </Button>
        </div>
      </ModalPopUp>

      <ToastMessage
        message={
          <>
            <p className="fs16 fw600">Invitation sent</p>
            <p className="fs14 m-b-0">The invitation was successfully sent.</p>
          </>
        }
        open={emailSentToast}
        setOpen={setEmailSentToast}
      />

      <ToastMessage
        message={
          <>
            <p className="fs16 fw600">User updated</p>
            <p className="fs14 m-b-0">
              You successfully updated {userToEdit.email}.
            </p>
          </>
        }
        open={updateUserToast}
        setOpen={setUpdateUserToast}
      />

      <ToastMessage
        message={
          <>
            <p className="fs16 fw600">User deactivated</p>
            <p className="fs14 m-b-0">
              You successfully deactivated {userToEdit.email}.
            </p>
          </>
        }
        open={deactivateUserToast}
        setOpen={setDeactivateUserToast}
      />

      <ToastMessage
        message={
          <>
            <p className="fs16 fw600">User activated</p>
            <p className="fs14 m-b-0">
              You successfully activated {userToEdit.email}.
            </p>
          </>
        }
        open={activateUserToast}
        setOpen={setActivateUserToast}
      />

      <ToastMessage
        message={
          <>
            <p className="fs16 fw600">User deleted</p>
            <p className="fs14 m-b-0">
              You successfully deleted {userToEdit.email}.
            </p>
          </>
        }
        open={deleteUserToast}
        setOpen={setDeleteUserToast}
      />
    </div>
  )
}

export default UserLibrary
